import React, { useState } from "react";
import './DiamondViewer.css';
const images = [
  {
    id: 1,
    name: "Emerald Pie Cut Diamond",
    src: "/assets/images/DiamondViewer/icon-6.png",
    details: {
      size: "0.07 CTS - 1.00 CTS",
      color: "D-E-F G-H-I-J-K",
      clarity: "IF,VVS,VS,SI",
      polish: "EX VG / VG VG",
    },
    img_urls: ["/assets/images/DiamondViewer/IMG_3.png"],
  },
  {
    id: 2,
    name: "Matching Pair Cut Diamond",
    src: "/assets/images/DiamondViewer/icon-2.png",
    details: {
      size: "0.10 CTS - 1.00 CTS",
      color: "D-E-F G-H-I-J-K",
      clarity: "IF,VVS,VS,SI",
      polish: "EX VG / VG VG",
    },
    img_urls: [
      "/assets/images/DiamondViewer/IMG_5.png",
      "/assets/images/DiamondViewer/trilliant-shape-cut-diamond.png",
      "/assets/images/DiamondViewer/hexagon-step-cut-diamond.png",
      "/assets/images/DiamondViewer/hexagon-brilliant-cut-diamond.png",
      "/assets/images/DiamondViewer/half-moon-brilliant-cut-diamond.png",
    ],
  },
  {
    id: 3,
    name: "Pie Cut Diamond",
    src: "/assets/images/DiamondViewer/icon-5.png",
    details: {
      size: "0.20 CTS - 1.00 CTS",
      color: "D-E-F G-H-I-J-K",
      clarity: "IF,VVS,VS,SI",
      polish: "EX VG / VG VG",
    },
    img_urls: [
      "/assets/images/DiamondViewer/oval-cut-diamond.png",
      "/assets/images/DiamondViewer/star-cut-diamond.png",
    ],
  },
  {
    id: 4,
    name: "Full Cut Diamond",
    src: "/assets/images/DiamondViewer/full-cut-diamond-icon.png",
    details: {
      size: "0.003CTS - 1.00 CTS",
      color: "D-E-F-G-H-I-J-K",
      clarity: "IF,VVS,VS,SI",
      polish: "EX VG / VG VG",
    },
    img_urls: ["/assets/images/DiamondViewer/full-cut-diamond.png"],
  },
  {
    id: 5,
    name: "Single Cut Diamond 8/8",
    src: "/assets/images/DiamondViewer/icon-4.png",
    details: {
      size: "0.001 CTS - 1.00 CTS",
      color: "D-E-F G-H-I-J-K",
      clarity: "IF,VVS,VS,SI",
      polish: "EX VG / VG VG",
    },
    img_urls: ["/assets/images/DiamondViewer/single-cut-diamond.png"],
  },
  {
    id: 6,
    name: "Fancy Shape Diamond",
    src: "/assets/images/DiamondViewer/icon-2-01.png",
    details: {
      size: "0.03 CTS - 1.00 CTS",
      color: "D-E-F G-H-I-J-K",
      clarity: "IF,VVS,VS,SI",
      polish: "EX VG / VG VG",
    },
    img_urls: [
      "/assets/images/DiamondViewer/oval-diamond.png",
      "/assets/images/DiamondViewer/marquise-diamond.png",
      "/assets/images/DiamondViewer/pear-diamond.png",
      "/assets/images/DiamondViewer/emerald-diamond.png",
      "/assets/images/DiamondViewer/asscher-diamond.png",
      "/assets/images/DiamondViewer/radiant-diamond.png",
      "/assets/images/DiamondViewer/heart-diamond.png",
    ],
  },
];

const DiamondViewer = () => {
  const [selectedImage, setSelectedImage] = useState(images[0]);
  const [selectedImageUrl, setSelectedImageUrl] = useState(
    images[0].img_urls[0]
  );
  const [rotation, setRotation] = useState(0);

  const rotateToImage = (imageIndex) => {
    const targetRotation = -(imageIndex * (360 / images.length)); // Calculate target rotation
    setRotation(targetRotation); // Update rotation to align the selected image to the top
  };

  const rotateLeft = () => {
    const currentIndex = images.findIndex((img) => img.id === selectedImage.id);
    const newIndex = (currentIndex - 1 + images.length) % images.length;
    setSelectedImage(images[newIndex]);
    setSelectedImageUrl(images[newIndex].img_urls[0]);
    rotateToImage(newIndex);
  };

  const rotateRight = () => {
    const currentIndex = images.findIndex((img) => img.id === selectedImage.id);
    const newIndex = (currentIndex + 1) % images.length;
    setSelectedImage(images[newIndex]);
    setSelectedImageUrl(images[newIndex].img_urls[0]);
    rotateToImage(newIndex);
  };

  return (
    
    <div className="flex flex-col lg:flex-row items-center justify-center min-h-screen rounded-sm bg-white p-8">
      
      {/* Left Panel */}
      <div className="w-full lg:w-1/2 p-6 text-white bg-slate-400 rounded-lg shadow-md flex flex-col items-center">
        <h2 className="text-4xl font-bold text-center mb-6">
          {selectedImage.name}
        </h2>
        <div className="relative mb-6">
          <img
            src={selectedImageUrl}
            alt="Selected"
            className="w-80 h-80 object-contain border-2 border-gray-500 rounded-lg shadow-lg"
          />
        </div>
        <div className="flex gap-3 justify-center mb-6">
          {selectedImage.img_urls.map((imgUrl, index) => (
            <img
              key={index}
              src={imgUrl}
              alt={`Thumbnail ${index + 1}`}
              className={`w-14 h-14 object-cover border-2 cursor-pointer ${
                selectedImageUrl === imgUrl
                  ? "border-blue-400"
                  : "border-gray-600"
              } rounded-md transition-transform transform hover:scale-110`}
              onClick={() => setSelectedImageUrl(imgUrl)}
            />
          ))}
        </div>
        <div className="text-lg text-left w-full max-w-md space-y-4 xl:ml-32">
          <p>
            <strong className="font-semibold">Size:</strong>{" "}
            {selectedImage.details.size}
          </p>
          <p>
            <strong className="font-semibold">Color:</strong>{" "}
            {selectedImage.details.color}
          </p>
          <p>
            <strong className="font-semibold">Clarity:</strong>{" "}
            {selectedImage.details.clarity}
          </p>
          <p>
            <strong className="font-semibold">Polish/Symmetry:</strong>{" "}
            {selectedImage.details.polish}
          </p>
        </div>
      </div>

      {/* Right Panel */}
      <div className="w-full lg:w-1/2 relative flex items-center justify-center flex-col right-panel">
        <div className="w-96 h-96 rounded-full bg-gray-800 relative flex items-center justify-center circle-container">
          <div className="w-60 h-60 rounded-full absolute flex items-center justify-center ">
            <img
              src="/assets/images/DiamondViewer/circle-spin.gif"
              alt="Rotating Diamond"
              className="w-full h-full object-contain filter brightness-75 saturate-150"
            />
          </div>
          <div
            className="absolute inset-0 flex items-center justify-center set-inset"
            style={{
              transform: `rotate(${rotation}deg)`,
              transition: "transform 0.5s ease-in-out",
            }}
          >
            {images.map((image, index) => {
                const translateValue = window.innerWidth <= 768 ? -130 : -150;

              const isSelected = image.id === selectedImage.id;
              return (
                <div
                  key={image.id}
                  className={`diamond-icon absolute hover:brightness-150 transition-transform duration-300 ease-in-out hover:scale-105 ${
                    isSelected ? "z-10" : "z-0"
                  }`}
                  style={{
                    transform: `rotate(${
                      index * (360 / images.length)
                    }deg) translate(0, ${translateValue}px) rotate(-${
                      rotation + index * (360 / images.length)
                    }deg)`,
                  }}
                >
                  <img
                    src={image.src}
                    alt={image.name}
                    className="w-12 h-12 object-contain cursor-pointer transition-transform duration-300 group-hover:scale-110"
                    onClick={() => {
                      setSelectedImage(image);
                      setSelectedImageUrl(image.img_urls[0]);
                      rotateToImage(index);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <button
          onClick={rotateLeft}
          className="absolute left-16 transform -translate-y-1/2 transition duration-300 hover:scale-110 hover:opacity-80"
        >
          <img src="/assets/images/previous-arrow-blue.png" alt="Rotate Left" />
        </button>
        <button
          onClick={rotateRight}
          className="absolute right-16 transform -translate-y-1/2 transition duration-300 hover:scale-110 hover:opacity-80"
        >
          <img src="/assets/images/next-arrow-blue.png" alt="Rotate Right" />
        </button>
      </div>
    </div>
  );
};

export default DiamondViewer;
